import { NgTemplateOutlet } from '@angular/common';
import { Component, TemplateRef, untracked, viewChild } from '@angular/core';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';

@Component({
  selector: 'sheba-drawer',
  exportAs: 'drawer',
  templateUrl: 'drawer.component.html',
  standalone: true,
  host: {
    class: 'contents'
  },
  imports: [MatSidenavModule, NgTemplateOutlet]
})
export class ShebaDrawerComponent<T> {
  drawer = viewChild.required(MatDrawer);

  templateRef?: TemplateRef<T>;
  context?: T;

  open(templateRef: TemplateRef<T>, context: T) {
    this.context = context;
    this.templateRef = templateRef;
    untracked(this.drawer).open();
  }

  close() {
    untracked(this.drawer).close();
    this.templateRef = undefined;
    this.context = undefined;
  }
}
